export enum REDO_OUTBOUND_CARRIER_IDS {
  FEDEX_SMARTPOST = "ca_f996de1247154d2b84c4e51f3df913f6",
  FEDEX = "ca_19dd1198bb3d462ea25612b34f04d6a7",
  EASYPOST_USPS = "ca_fa25281c95a445939738a4725bd9c2b5",
  B2B_UPS = "ca_4011dee962d44d3db1d05d9aea5549a3",
  B2C_UPS = "ca_1ae50b34cac648a2a12f8978ce65b049",
  USPS_SHIP = "ca_58a3433030904f4f86c1eb33a6a1aa47", // Note: Sometimes we have problems manifesting USPS Ship - see explanation here: https://github.com/redoapp/redo/pull/16662
  AMAZON = "ca_beb146dd1f7944f3b9fb6d564a615f96",
  UPS_DYNAMIC = "ca_b22b08164cb14a02bea564b84208d11d",
  UPS_GROUND_SAVER_DYNAMIC = "ca_aa54b60b48a54be79e90eb6cb5154447",
  RETURN_BEAR_AUSTRALIA_POST = "ca_76d6ebe306dd453cb3fc56fb0a471d50",
  EPOST_GLOBAL = "ca_7c85df2facf246bf8aef41c24c002383",
  EPOST_GLOBAL_LCG = "ca_d7a53fadeb274785a1d874195a1ce8bb",
  APC = "ca_3bfef8e67a5649d18bc4b064e6c8b5df",
  APC_LCG = "ca_a91ef57dbb8b4842afca7a991c51a767",
}

export const DEFAULT_CARRIER_ACCOUNTS = [
  REDO_OUTBOUND_CARRIER_IDS.FEDEX_SMARTPOST,
  REDO_OUTBOUND_CARRIER_IDS.FEDEX,
  REDO_OUTBOUND_CARRIER_IDS.B2B_UPS,
  REDO_OUTBOUND_CARRIER_IDS.B2C_UPS,
  REDO_OUTBOUND_CARRIER_IDS.UPS_DYNAMIC,
  REDO_OUTBOUND_CARRIER_IDS.UPS_GROUND_SAVER_DYNAMIC,
  // This should ONLY be used for getting USPS letter rates
  REDO_OUTBOUND_CARRIER_IDS.EASYPOST_USPS,
] as readonly REDO_OUTBOUND_CARRIER_IDS[];
